require('./modifyDebitLimitsInformativeSection.scss');
const PropTypes = require('prop-types');
//@vendor
const React = require('react');
//@commons
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { FormattedText } = require('core/i18n').i18n;
//@utilities
const { getFormattedString } = require('utilities/currencyHelper');
//@constants
const { FIRST_STEP } = require('constants/index');

class ModifyDebitLimitsInformativeSection extends React.Component {
    buildInformativeList() {
        const { immCard, immCardModifyDebitLimits } = this.props;

        const immStepOne = immCardModifyDebitLimits.getIn(['steps', FIRST_STEP]);
        const immCurrentLimits = immCardModifyDebitLimits.getIn(['debitLimits', immCardModifyDebitLimits.get('operationType')]);

        const currentLimit = getFormattedString({
            amount: immCurrentLimits.get('currentLimit'),
            currency: immCurrentLimits.get('currency'),
            decimalsLength: 0
        });

        const informativeItems = [
            <OKInformativeListItem
                key="modifyDebitLimitsInformativeSection-contractNumber"
                title="modifyDebitLimitsInformativeSection-contractNumber"
                bodyText={immCard.get('fullContractNumber')}
            />,
            <OKInformativeListItem
                key="modifyDebitLimitsInformativeSection-cardHolder"
                title="modifyDebitLimitsInformativeSection-cardHolder"
                bodyText={immCard.get('titularName')}
            />,
            <OKInformativeListItem
                key="modifyDebitLimitsInformativeSection-currentLimit"
                title="modifyDebitLimitsInformativeSection-currentLimit"
                bodyText={currentLimit}
            />
        ];

        if (immCardModifyDebitLimits.get('visibleStep') !== 1) {
            const limit = getFormattedString({
                amount: immStepOne.get('limit'),
                currency: immStepOne.get('currency'),
                decimalsLength: 0
            });

            informativeItems.push(
                <OKInformativeListItem
                    key="modifyDebitLimitsInformativeSection-newLimit"
                    title="modifyDebitLimitsInformativeSection-newLimit"
                    bodyText={limit}
                />
            );
        }

        return (
            <OKInformativeList columns={2}>
                {informativeItems}
            </OKInformativeList>
        );
    }

    render() {
        const InformativeList = this.buildInformativeList();

        return (
            <section className="modify-debit-limits-informative-section">
                <header className="modify-debit-limits-informative-section__header">
                    <FormattedText value={this.props.titleKey} />
                </header>
                <div className="modify-debit-limits-informative-section__body">
                    {InformativeList}
                </div>
            </section>
        );
    }
}

ModifyDebitLimitsInformativeSection.propTypes = {
    immCard: PropTypes.object.isRequired,
    immCardModifyDebitLimits: PropTypes.object.isRequired,
    titleKey: PropTypes.string.isRequired,
};

module.exports = ModifyDebitLimitsInformativeSection;
